module.exports = __webpack_public_path__ + "static/media/erc20.90607899.svg";